(() => {
  const selectors = {
    card: '.md-product-card',
    swatch: '[data-product-card-swatch]',
    image: '.md-product-card__image img',
    link: '[data-product-card-link]',
    price: '[data-product-card-price]',
    sellingPlanInput: '[data-selling-plan-input]',
    submit: '[data-product-submit]',
    variantInput: '[data-product-variant-id]',
  };

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function updateProductCardFromSwatch(swatch) {
    const card = swatch.closest(selectors.card);
    if (!card || !swatch.dataset.variantId) return false;

    card.querySelectorAll(selectors.swatch).forEach((candidate) => {
      const selected = candidate === swatch;
      candidate.classList.toggle(
        'md-product-card__swatch-dot--selected',
        selected,
      );
      if (selected) {
        candidate.setAttribute('aria-current', 'true');
      } else {
        candidate.removeAttribute('aria-current');
      }
    });

    card.querySelectorAll(selectors.variantInput).forEach((input) => {
      input.value = swatch.dataset.variantId;
    });

    card.querySelectorAll(selectors.sellingPlanInput).forEach((input) => {
      input.value = swatch.dataset.sellingPlanId || '';
    });

    if (swatch.dataset.variantPrice) {
      card.querySelectorAll(selectors.price).forEach((price) => {
        price.textContent = swatch.dataset.variantPrice;
      });
    }

    if (swatch.dataset.variantUrl) {
      card.querySelectorAll(selectors.link).forEach((link) => {
        link.href = swatch.dataset.variantUrl;
      });
    }

    const image = card.querySelector(selectors.image);
    if (image && swatch.dataset.variantImageSrc) {
      image.src = swatch.dataset.variantImageSrc;
      if (swatch.dataset.variantImageSrcset) {
        image.srcset = swatch.dataset.variantImageSrcset;
      }
      if (swatch.dataset.variantImageAlt) {
        image.alt = swatch.dataset.variantImageAlt;
      }
    }

    const available = swatch.dataset.variantAvailable !== 'false';
    card.querySelectorAll(selectors.submit).forEach((button) => {
      const addLabel = button.dataset.addLabel || 'Add to cart';
      const soldOutLabel = button.dataset.soldOutLabel || 'Out of stock';
      button.disabled = !available;
      button.dataset.variantAvailable = available ? 'true' : 'false';
      button.classList.toggle('md-btn-text', available);
      button.classList.toggle('md-btn-disabled', !available);
      if (available) {
        button.removeAttribute('aria-disabled');
        button.innerHTML = `${escapeHtml(addLabel)} <span aria-hidden="true">→</span>`;
      } else {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = soldOutLabel;
      }
    });

    document.dispatchEvent(
      new CustomEvent('medistik:product-card:variant-change', {
        bubbles: true,
        detail: {
          card,
          swatch,
          variantId: swatch.dataset.variantId,
          variantUrl: swatch.dataset.variantUrl || '',
          available,
        },
      }),
    );

    return true;
  }

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(selectors.swatch);
    if (!swatch) return;
    if (!updateProductCardFromSwatch(swatch)) return;
    event.preventDefault();
  });

  window.MedistikProductCard = {
    updateFromSwatch: updateProductCardFromSwatch,
  };
})();
